import { FC, useState } from "react";
import { PrimaryButton } from "../../Styles/Styles";
import { useForm } from "react-hook-form";
import { SilentRequest } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { Company } from "../../data/interfaces/company";
import { updateCompany } from "../../data/companyService";
import Select from 'react-select';

type FormData = {
  companyId: number;
  licenseCount: number;
  mobileLicenseCount: number;
  trialLicenseCount: number;
  terminal: boolean;
  reason: number;
};

type Props = {
  company: Company | undefined;
};

const LicenseForm: FC<Props> = ({ company }) => {
  
  const { register, handleSubmit, errors } = useForm<FormData>({
    mode: "onBlur",
  });

  const { instance } = useMsal();
  const navigate = useNavigate();
  const options = [
    { value: false, label: 'No' },
    { value: true, label: 'Yes' }
  ];

  let initIndex = 0;

  if (company?.terminalYN === true)
     initIndex = 1;     

  const [terminalSelect, setTerminalSelect] = useState<number>(initIndex);

    const handleSelectChange = () => {
      if (terminalSelect === 0) 
        setTerminalSelect(1)              
      else 
        setTerminalSelect(0)      
  };

  const submitForm = async (data: FormData) => {
    const account = instance.getAllAccounts()[0];
    const user = account.name;

    const silentRequest: SilentRequest = {
      scopes: ["api://a22e7296-106f-4a00-af8d-f86edb386a1b/api_access"],
      account: account,
    };

    const token = await instance.acquireTokenSilent(silentRequest);

    data.terminal = options[terminalSelect].value

    if (data.licenseCount !== company?.licenses || data.mobileLicenseCount !== company?.licensesMobileCount|| data.trialLicenseCount !== company?.trialLicenses)
    {
      await updateCompany(
        {
          companyId: data.companyId,
          accountNumber: 0,
          licenses: data.licenseCount,
          licensesMobileCount: data.mobileLicenseCount,
          trialLicenses: data.trialLicenseCount,
          terminalYN: data.terminal,
          reason: data.reason.toString(),
          changedBy: user
        },
        token.accessToken
      );
    }

    navigate("/");
  };

  return (
    <div className="mb-4">
      <h5>Update Licenses</h5>
      <form onSubmit={handleSubmit(submitForm)} className="form-horizontal">
        <input
          ref={register}
          defaultValue={company?.companyId}
          type="text"
          name="companyId"
          id="companyId"
          hidden
          readOnly
        />
        <div className="row mb-2">
          <div className="col">
            <label className="form-label" htmlFor="licenseCount">
              Desktop
            </label>
            <input
              ref={register}
              defaultValue={company?.licenses}
              type="number"
              min="1"
              id="licenseCount"
              name="licenseCount"
              className="form-control col-2"
            />
          </div>
          <div className="col">
            <label className="form-label" htmlFor="mobileLicenseCount">
              Mobile
            </label>
            <input
              ref={register}
              defaultValue={company?.licensesMobileCount}
              type="number"
              min="0"
              id="mobileLicenseCount"
              name="mobileLicenseCount"
              className="form-control col-2"
            />
          </div>
          <div className="col">
            <label className="form-label" htmlFor="trialLicenseCount">
              Trial
            </label>
            <input
              ref={register}
              defaultValue={company?.trialLicenses}
              type="number"
              min="0"
              id="trialLicenseCount"
              name="trialLicenseCount"
              className="form-control col-2"
            />
          </div>
        </div>

        <div className="row mb-2">
          <div className="col">     
            <label className="form-label">Terminal</label>
            <Select                   
                    id="terminal"
                    name="terminal"
                    options={options}
                    value={options[terminalSelect]}                    
                    defaultValue={options[terminalSelect]}
                    onChange={handleSelectChange}
                />
          </div>
          <div className="col">     
              <label className="form-label">Hubspot Ticket ID</label>
              <input type='number' id="reason" name="reason" className="form-control col-2"
              ref={register({ required: true, minLength: 10 })} />

              {errors.reason && errors.reason.type === "required" && (
                    <span className="errors">This field is required</span>
                  )}
              {errors.reason && errors.reason.type === "minLength" && (
                    <span className="errors">Please input a valid ID</span>
                  )}
          </div>
          <div className="col d-flex align-items-end">
            <div className="">
              <PrimaryButton 
                className="btn"
                type="submit"
                id="btn-submit"
                style={{ width: "150px" }}
              >
                Submit
              </PrimaryButton>
            </div>
          </div>
        </div>
        
      </form>
    </div>
  );
};

export default LicenseForm;
